// extracted by mini-css-extract-plugin
export default {"foodCardPage":"MainFood_foodCardPage__s5obr","foodCard":"MainFood_foodCard__fwxyI","foodCardName":"MainFood_foodCardName__VsH60","foodCardimg":"MainFood_foodCardimg__OhdHo"};